import React, { useState } from 'react';
import PropTypes from 'prop-types';

import FormModal from 'components/form_modal';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export default function EditModal({ companyOffice, features, showOfficeName, onCancel, onSave, onSubmit }) {
  const [form, setForm] = useState({});
  const show = companyOffice != null;

  const handleChange = (change) => {
    setForm({
      ...form,
      ...change,
    });
  };

  const handleSave = () => {
    onSave({
      ...companyOffice,
      ...form
    });
  };

  return (
    <FormModal
      header="Invoices"
      show={show}
      onCancel={onCancel}
      onShow={() => setForm({ ...companyOffice, nextInvoiceNumber: null })}
      onSubmit={() => onSubmit(form)}
      onSuccess={handleSave}
    >
      <div className="form-group text optional">
        {showOfficeName &&
          <div className="form form-horizontal">
            <ManagedFormGroup
              disabled
              label="Office"
              name="name"
              value={(companyOffice || {}).name}
            />
          </div>
        }
        <div className="form form-horizontal">
          <ManagedFormGroup
            disabled={features?.moCustomDealIds}
            label="Invoice Number Prefix"
            name="invoiceIdentifierPrefix"
            value={form.invoiceIdentifierPrefix}
            onChange={handleChange}
          />
        </div>
        <div className="form form-horizontal">
          <ManagedFormGroup
            disabled={features?.moCustomDealIds}
            label="Next Invoice Number"
            name="nextInvoiceNumber"
            placeholder={(companyOffice || {}).nextInvoiceNumber}
            type="number"
            value={form.nextInvoiceNumber}
            onChange={handleChange}
          />
        </div>
        <div className="form form-horizontal">
          <ManagedFormGroup
            label="Remit To"
            name="backofficeInvoicePaymentInstructions"
            type="textarea"
            value={form.backofficeInvoicePaymentInstructions}
            onChange={handleChange}
          />
        </div>
        <div className="form form-horizontal">
          <ManagedFormGroup
            label="Notes"
            name="backofficeInvoiceNotes"
            type="textarea"
            value={form.backofficeInvoiceNotes}
            onChange={handleChange}
          />
        </div>
      </div>
    </FormModal>
  );
}

EditModal.propTypes = {
  companyOffice: PropTypes.shape({
    backofficeInvoiceNotes: PropTypes.string,
    backofficeInvoicePaymentInstructions: PropTypes.string,
    invoiceIdentifierPrefix: PropTypes.string,
    name: PropTypes.string,
    nextInvoiceNumber: PropTypes.number,
  }),
  features: PropTypes.shape({
    moCustomDealIds: PropTypes.bool,
  }),
  showOfficeName: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
